export default {
      id: "Alt3-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Alt3",
      toString: function () {
        return this.url;
      }
    }